import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FlyFreelyConstants } from '../../constants';
import { AvailableReportDto } from '../../model/api';
import { httpParamSerializer } from '../service.helpers';

@Injectable({
    providedIn: 'root'
})
export class MissionReportService {
    private baseUrl: string;

    constructor(constants: FlyFreelyConstants, private http: HttpClient) {
        this.baseUrl = constants.API_URL;
    }

    findAvailableTemplates(
        reportEventIdentifier: string,
        missionId: number,
        managingOrganisationId: number
    ) {
        return this.http.get<AvailableReportDto[]>(
            `${this.baseUrl}/reportsapi/missions/${missionId}`,
            {
                params: httpParamSerializer({
                    reportEventIdentifier,
                    managingOrganisationId
                })
            }
        );
    }

    findAvailableMissionListTemplates(
        reportEventIdentifier: string,
        managingOrganisationId: number
    ) {
        return this.http.get<AvailableReportDto[]>(
            `${this.baseUrl}/reportsapi/missions`,
            {
                params: httpParamSerializer({
                    reportEventIdentifier,
                    managingOrganisationId
                })
            }
        );
    }

    getHtmlReportUrl(
        reportTemplateId: number,
        missionId: number,
        managingOrganisationId: number
    ) {
        const params = httpParamSerializer({
            managingOrganisationId,
            format: 'pdf'
        }).toString();

        return `${this.baseUrl}/reportsapi/missions/${missionId}/render/${reportTemplateId}?${params}`;
    }

    getPdfReportUrl(
        reportTemplateId: number,
        missionId: number,
        managingOrganisationId: number
    ) {
        const params = httpParamSerializer({
            managingOrganisationId,
            format: 'pdf'
        }).toString();

        return `${this.baseUrl}/reportsapi/missions/${missionId}/render/${reportTemplateId}?${params}`;
    }

    getMissionListReportUrl(
        organisationId: number,
        orOrganisationId: number,
        authorityIds: number[],
        startTime: string,
        endTime?: string
    ) {
        const params = httpParamSerializer({
            organisationId,
            orOrganisationId,
            authorityIds,
            startTime,
            endTime
        }).toString();

        return `${this.baseUrl}/reportsapi/missions/aggregate?${params}`;
    }

    getFlightReportUrl(
        organisationId: number,
        orOrganisationId: number,
        authorityIds: number[],
        startTime: string,
        endTime?: string,
        withFlightLogs?: boolean
    ) {
        const params = httpParamSerializer({
            organisationId,
            orOrganisationId,
            authorityIds,
            startTime,
            endTime,
            withFlightLogs:
                withFlightLogs != null ? withFlightLogs.toString() : null
        }).toString();

        return `${this.baseUrl}/reportsapi/missions/flightAggregate?${params}`;
    }

    getMissionsPdfUrl(
        reportTemplateId: number,
        organisationId: number,
        orOrganisationId: number,
        managingOrganisationId: number,
        startTime: string,
        endTime?: string,
        authorityIds?: number[]
    ) {
        const params = httpParamSerializer({
            organisationId,
            orOrganisationId,
            managingOrganisationId,
            startTime,
            endTime,
            authorityIds,
            format: 'pdf'
        }).toString();

        return `${this.baseUrl}/reportsapi/missions/render/${reportTemplateId}?${params}`;
    }
}
